import { render, staticRenderFns } from "./PasswordModal.vue?vue&type=template&id=9c907b16"
import script from "./PasswordModal.vue?vue&type=script&lang=ts"
export * from "./PasswordModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports